import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Sparkles } from "lucide-react";

const ENTRIES = [
  {
    title: "Persistent Filters & Lead Count",
    description: "Your filters are now remembered when you switch pages and come back. You'll also see a count of how many leads match your current filters.",
    date: "03 Jul 2026",
  },
  {
    title: "Export to CSV",
    description: "Download your leads list as a spreadsheet with one click.",
    date: "22 Jun 2026",
  },
  {
    title: "Follow-ups System",
    description: "Set reminders to follow up with leads on a specific date and time.",
    date: "12 Jun 2026",
  },
  {
    title: "Activity Timeline",
    description: "See a full history of every call, WhatsApp message, and email logged for each lead.",
    date: "29 Jun 2026",
  },
  {
    title: "Kanban Board",
    description: "View and manage your leads visually by dragging them between stages.",
    date: "12 Jun 2026",
  },
  {
    title: "Google Ads Style Date Picker",
    description: "Quickly filter leads by date ranges like \"Last 7 days\", \"This month\", etc.",
    date: "01 Jul 2026",
  },
  {
    title: "Dashboard with Charts",
    description: "Visual overview of your leads by source, stage, and conversion performance.",
    date: "12 Jun 2026",
  },
];

export default function WhatsNewModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg bg-white max-h-[85vh] overflow-y-auto" data-testid="whats-new-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-[#6C47FF]" /> What's New
          </DialogTitle>
        </DialogHeader>
        <p className="text-xs text-[#6B7280] -mt-2">Recent updates to your Lead Management System, newest first.</p>
        <div className="space-y-3 mt-2" data-testid="whats-new-list">
          {ENTRIES.map((e, i) => (
            <div
              key={i}
              data-testid={`whats-new-item-${i}`}
              className="border border-[#E8EAEF] rounded-[8px] p-4 bg-white hover:bg-[#F0F1F7] transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="text-sm font-[600] text-[#1A1A2E]">{e.title}</div>
                <span
                  className="flex-shrink-0 text-[11px] font-[600]"
                  style={{ backgroundColor: "#6C47FF", color: "#ffffff", borderRadius: "4px", padding: "2px 6px" }}
                >
                  {e.date}
                </span>
              </div>
              <div className="text-sm text-[#6B7280] mt-1.5 leading-snug">{e.description}</div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
